<template>
	<div id='propi-editar'>
		<h2>EDITAR PROPIEDAD </h2>
		<div id='propiedad-ver'>
		<form v-on:submit.prevent= 'guardarPropiedad'>
			<table align="center">
				<tr>
					<td>nombreCompleto</td>
					<td>
						<input type='text' name='nombreCompleto' autofocus required autocomplete v-model='propiedades.nombreCompleto' >
					</td>
				</tr>
				<tr>
				<td>familia</td>
				<td>
					<input type='text' name='familia' required autocomplete v-model='propiedades.familia' >
				</td>
				</tr>
				<tr>
				<td>subfamilia</td>
				<td>
					<input type='text' name='subfamilia' autocomplete v-model='propiedades.subfamilia' >
				</td>
				</tr>
				<tr>
				<td>dueño</td>
				<td>
					<input type='text' name='dueno' autocomplete v-model='propiedades.dueno' >
				</td>
				</tr>

				<tr>
				<td>tipo</td>
					<td>
					<input type='text' name='tipo' required v-model='propiedades.tipo' >
					</td>
				</tr>
				<tr>
				<td>claveCatastral</td>
					<td><input type='text' name='claveCatastral' v-model='propiedades.claveCatastral' >
					</td>
				</tr>
				<tr>
				<td>pais</td>
					<td><input type='text' name='pais' required value='Mexico' v-model='propiedades.pais' >
					</td>
				</tr>
				<tr>
				<td>dirCalle</td>
					<td><input type='text' name='dirCalle' required v-model='propiedades.dirCalle' >
					</td>
				</tr>
				<tr>
				<td>dirNumero</td>
					<td><input type='text' name='dirNumero' required number v-model='propiedades.dirNumero' >
					</td>
				</tr>
				<tr>
				<td>dirInterior</td>
					<td><input type='text' name='dirInterior' v-model='propiedades.dirInterior' >
					</td>
				</tr>
				<tr>
				<td>dirCiudad</td>
					<td><input type='text' name='dirCiudad' autocomplete required v-model='propiedades.dirCiudad' >
					</td>
				</tr>
				<tr>
				<td>dirEstado</td>
					<td><input type='text' name='dirEstado' required v-model='propiedades.dirEstado' >
					</td>
				</tr>
				<tr>
				<td>dirCodigo</td>
					<td><input type='text' name='dirCodigo' number v-model='propiedades.dirCodigo' >
					</td>
				</tr>
				<tr>
				<td>metrosCuadrados</td>
					<td><input type='text' name='metrosCuadrados' number v-model='propiedades.metrosCuadrados' >
					</td>
				</tr>

                <tr>
                <td>Contrato de luz</td>
                    <td><input type='text' name='cl' number v-model='propiedades.contratoElec' >
                    </td>
                </tr>
                <tr>
                <td>Medidor de luz</td>
                    <td><input type='text' name='ml' number v-model='propiedades.medidorElec' >
                    </td>
                </tr>
                <tr>
                <td>Medidor de luz a nombre de</td>
                    <td><input type='text' name='mln' number v-model='propiedades.AnombreDeElec' >
                    </td>
                </tr>
                <tr>
                <td>Comentarios de toma de Luz</td>
                    <td><input type='text' name='ctl' number v-model='propiedades.comentarioMedidorE' >
                    </td>
                </tr>  

                <tr>
                <td>Contrato de Agua</td>
                    <td><input type='text' name='ca' number v-model='propiedades.contratoAgua' >
                    </td>
                </tr>
                <tr>
                <td>Medidor de Agua</td>
                    <td><input type='text' name='ma' number v-model='propiedades.medidorAgua' >
                    </td>
                </tr>   
                <tr>
                <td>Contrato de Agua a nombre de</td>
                    <td><input type='text' name='can' number v-model='propiedades.AnombreDeAgua' >
                    </td>
                </tr>  
                <tr>
                <td>Comentarios de toma de Agua</td>
                    <td><input type='text' name='cta' number v-model='propiedades.comentarioAgua' >
                    </td>
                </tr>   
                <tr>
                <td>Medidas y colindancias</td>
                    <td>
                        <textarea type='text' name='cta' number v-model='propiedades.medidasYcol' >
                        </textarea>
                    </td>
                </tr>                


			</table>
			<br>
			<input type="submit" name="agregandoPropiedad">
		</form>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default{
			name:'editar-propiedad',
			mounted(){
				this.entrar();
			},
			props:['vector'],
			data(){
				return {
					id: null,
					propiedades:{
						nombreCompleto:'',
						familia:'',
						subfamilia:'',
						dueno:'',
						tipo:'',
						claveCatastral:'',
						pais:'',
						dirCalle:'',
						dirNumero:'',
						dirInterior:'',
						dirCiudad:'',
						dirEstado:'',
						dirCodigo:'',
						metrosCuadrados:'',
                        medidorElec:'',
                        contratoElec:'',
                        AnombreDeElec:'',
                        comentarioMedidorE:'',
                        medidorAgua:'',
                        contratoAgua:'',
                        AnombreDeAgua:'',
                        comentarioAgua:'',
                        medidasYcol:''
					}
					
				};
			},
			methods:{
				entrar(){
				// checa si tiene autorizacion
		  		if(!this.vector.includes('MASTERGGUV')){
			  		if(!this.vector.includes('Propiedades Editar')){
			  			document.getElementById('propiedad-ver').hidden = true;
			  			alert('Seccion no autorizada');
			  			return;
			  		}
			  	}
				var pro= ''; 
				var propiedades2= '';

				this.id=this.$route.params.id;
				axios.get('https://www.directodo.com/Rentus/accesosdb/leeUnaPropiedad.php?id='+this.id)
  		             .then((respue) => {
  		     			pro=respue.data;
  		     			
  		     			var x;
  		     			for (x in pro) {
    						propiedades2 = pro[x];
						}

						this.propiedades.nombreCompleto = propiedades2.nombreCompleto;
						this.propiedades.familia = propiedades2.familia;
						this.propiedades.subfamilia = propiedades2.subfamilia;
						this.propiedades.dueno = propiedades2.dueno;
						this.propiedades.tipo = propiedades2.tipo;
						this.propiedades.claveCatastral = propiedades2.claveCatastral;
						this.propiedades.pais = propiedades2.pais;
						this.propiedades.dirCalle = propiedades2.dirCalle;
						this.propiedades.dirNumero = propiedades2.dirNumero;
						this.propiedades.dirInterior = propiedades2.dirInterior;
						this.propiedades.dirCiudad = propiedades2.dirCiudad;
						this.propiedades.dirEstado = propiedades2.dirEstado;
						this.propiedades.dirCodigo = propiedades2.dirCodigo;
						this.propiedades.metrosCuadrados = propiedades2.metrosCuadrados
                        this.propiedades.medidorElec = propiedades2.medidorElec;
                        this.propiedades.contratoElec = propiedades2.contratoElec;
                        this.propiedades.AnombreDeElec = propiedades2.AnombreDeElec;
                        this.propiedades.comentarioMedidorE = propiedades2.comentarioMedidorE;
                        this.propiedades.medidorAgua = propiedades2.medidorAgua;
                        this.propiedades.contratoAgua = propiedades2.contratoAgua;
                        this.propiedades.AnombreDeAgua = propiedades2.AnombreDeAgua;
                        this.propiedades.comentarioAgua = propiedades2.comentarioAgua;
                        this.propiedades.medidasYcol = propiedades2.medidasYcol;

                        ;
  			 		 });
				},
				guardarPropiedad(){
					var propiedades2= this.propiedades;
					var router= this.$router;

					axios.post('https://www.directodo.com/Rentus/accesosdb/modificaPropiedad.php?id='+this.id+'&nombreCompleto='+propiedades2.nombreCompleto+'&familia='+propiedades2.familia+'&subfamilia='+propiedades2.subfamilia+'&dueno='+propiedades2.dueno+'&tipo='+propiedades2.tipo+'&claveCatastral='+propiedades2.claveCatastral+'&pais='+propiedades2.pais+'&dirCalle='+propiedades2.dirCalle+'&dirNumero='+propiedades2.dirNumero+'&dirInterior='+propiedades2.dirInterior+'&dirCiudad='+propiedades2.dirCiudad+'&dirEstado='+propiedades2.dirEstado+'&dirCodigo='+propiedades2.dirCodigo+'&mel='+propiedades2.medidorElec
                        +'&anomel='+propiedades2.AnombreDeElec
                        +'&comel='+propiedades2.comentarioMedidorE
                        +'&mea='+propiedades2.medidorAgua
                        +'&coagu='+propiedades2.contratoAgua
                        +'&anoma='+propiedades2.AnombreDeAgua
                        +'&comagu='+propiedades2.comentarioAgua
                        +'&conele='+propiedades2.contratoElec
                        +'&medYcol='+propiedades2.medidasYcol
                        +'&metrosCuadrados='+propiedades2.metrosCuadrados
                        +'&status=A&fechaModifica=01-01-18&quienModifico=GGUV')
		  		          .then((respue) => {
		  		          		if (respue.statusText == 'OK'){
		  		          			router.push('/pro')
		  		          		}
		  			 	  })
		  		          .catch((error) =>{
		  		          		console.log(error);
		  		          });
				}
			}
	}
</script>


// WEBPACK FOOTER //
// src/Propiedad-editar.vue